<template>
  <section class="bg-white p-4 md:p-8 block w-full border-t-4 border-primario shadow-md">
    <div class="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 md:gap-8">
      <!-- ==================== --->
      <!-- === FIRST COLUMN === --->
      <!-- ==================== --->
      <div class="flex flex-col items-center bg-gray-100 pb-8 my-8 md:mb-0">
        <div class="w-20 h-20 md:w-24 md:h-24 -mt-8 md:-mt-12 rounded-full bg-secundario">
          <div class="carta w-20 h-20 md:w-24 md:h-24">
            <svg
              class="w-12 h-12 fill-current text-gray-100"
              fill="none"
              xml:space="preserve"
              viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M40.28 4.61h-4.07C35.71 2.56 33.83 1 31.59 1s-4.12 1.56-4.62 3.61H22.9c-.5 0-.96.41-.96.96v4.53c0 .5.41.96.96.96h17.34c.5 0 .96-.41.96-.96V5.57c0-.54-.42-.96-.92-.96z" />
              <path d="M50.8 7.86h-7.87v3.39c0 .73-.59 1.28-1.28 1.28H21.57c-.73 0-1.28-.59-1.28-1.28V7.86h-7.91c-1.92 0-3.48 1.56-3.48 3.48v48.17c0 1.92 1.56 3.48 3.48 3.48h38.47c1.92 0 3.48-1.56 3.48-3.48V11.34c-.05-1.92-1.61-3.48-3.53-3.48zm-3.52 36.37H15.9c-.69 0-1.24-.55-1.24-1.24s.55-1.24 1.24-1.24h31.34c.69 0 1.24.55 1.24 1.24-.01.69-.56 1.24-1.2 1.24zm0-9.47H15.9c-.69 0-1.24-.55-1.24-1.24s.55-1.24 1.24-1.24h31.34c.69 0 1.24.55 1.24 1.24-.01.69-.56 1.24-1.2 1.24zm0-9.42H15.9c-.69 0-1.24-.55-1.24-1.24s.55-1.24 1.24-1.24h31.34c.69 0 1.24.55 1.24 1.24-.01.69-.56 1.24-1.2 1.24z" />
            </svg>
            <div class="absolute inset-y-0 flex items-center text-center">
              <span
                class="texto text-xs text-gray-200 font-semibold tracking-wide"
              >{{ $t("lang.msg.planning") }}</span>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-48 xl:w-56 space-y-2 mt-4">
          <HomeButtonRedirect :route="{ name: 'adminPrints' }">
            {{ $t("lang.msg.print") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminComplements' }">
            {{ $t("lang.msg.complements") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminConfection' }">
            {{ $t("lang.msg.confectionDetails") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminRefinements' }">
            {{ $t("lang.msg.refinements") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminTissues' }">
            {{ $t("lang.msg.tissues") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminColor' }">
            {{ $t("lang.msg.color") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminTypologies' }">
            {{ $t("lang.msg.typology") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminQualities' }">
            {{ $t("lang.msg.quality") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminWeights' }">
            {{ $t("lang.msg.weight") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminCompositions' }">
            {{ $t("lang.msg.composition") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminUbications' }">
            {{ $t("lang.fields.ubication") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminTitles' }">
            {{ $t("lang.msg.title") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminLus' }">
            {{ $t("lang.msg.lu") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminGalga' }">
            {{ $t("lang.msg.galga") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminArticle' }">
            {{ $t("lang.msg.article") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminSizes' }">
            {{ $t("lang.msg.size") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminIcoterm' }">
            {{ $t("lang.msg.icoterm") }}
          </HomeButtonRedirect>
        </div>
      </div>
      <!-- ===================== --->
      <!-- === SECOND COLUMN === --->
      <!-- ===================== --->
      <div class="flex flex-col items-center bg-gray-100 pb-8 my-8 md:mb-0">
        <div class="w-20 h-20 md:w-24 md:h-24 -mt-8 md:-mt-12 rounded-full bg-secundario">
          <div class="carta w-20 h-20 md:w-24 md:h-24">
            <svg
              class="w-12 h-12 fill-current text-gray-100"
              fill="none"
              xml:space="preserve"
              viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M47.95 40.62c-1.73-2.02-3.46-3.75-5.76-4.9 4.9-3.17 8.36-8.93 8.36-15.27C50.54 10.36 42.19 2 32.1 2s-18.44 8.36-18.44 18.44c0 6.34 3.17 12.1 8.36 15.27h-.29c-.58.58-1.44.86-2.02 1.44-4.61 3.46-6.92 8.07-8.07 13.55 0 .58 0 1.15.58 1.73.58.58 1.15 1.44 2.02 2.02.58-1.73 2.31-5.48 3.46-6.63 1.15-1.15-1.73 5.19-2.59 7.49 1.73 1.73 3.75 2.88 6.05 4.03 4.03 2.02 8.36 2.88 12.97 2.59 2.88-.29 5.48-.86 8.07-2.02 2.31-1.15 4.61-2.31 6.34-4.03-.29-1.73-4.03-9.22-2.59-8.07 1.15 1.15 3.17 5.76 3.75 7.21 1.15-.86 2.02-2.02 2.88-2.88v-.58c-.6-4.02-2.04-7.77-4.63-10.94zm-13.83-.58c-2.59.29-5.19 0-7.78-1.15-1.44-.58-2.88-1.73-4.03-2.88 2.88 1.73 6.05 2.88 9.8 2.88 3.46 0 6.92-1.15 9.51-2.88-2.03 2.3-4.33 3.46-7.5 4.03z" />
            </svg>
            <div class="absolute inset-y-0 flex items-center text-center">
              <span class="texto text-xs text-gray-200 font-semibold tracking-wide">
                {{ $t("lang.msg.users") }}
              </span>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-48 xl:w-56 space-y-2 mt-4">
          <HomeButtonRedirect :route="{ name: 'adminSignup' }">
            {{ $t("lang.msg.signUpUsers") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminUsers' }">
            {{ $t("lang.msg.userList") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminRoles' }">
            {{ $t("lang.msg.role") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminDepartments' }">
            {{ $t("lang.msg.department") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminCompanies' }">
            {{ $t("lang.msg.company") }}
          </HomeButtonRedirect>
        </div>
      </div>
      <!-- ==================== --->
      <!-- === THIRD COLUMN === --->
      <!-- ==================== --->
      <div class="flex flex-col items-center bg-gray-100 pb-8 my-8 md:mb-0">
        <div class="w-20 h-20 md:w-24 md:h-24 -mt-8 md:-mt-12 rounded-full bg-secundario">
          <div class="carta w-20 h-20 md:w-24 md:h-24">
            <svg
              class="w-12 h-12 fill-current text-gray-100"
              fill="none"
              xml:space="preserve"
              viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M48.86 41.1c-1.66-2.1-3.63-3.76-5.96-5.06 5.19-3.4 8.6-9.27 8.6-15.9C51.46 9.66 42.9 1.11 32.47 1.2c-10.44.09-18.99 8.6-18.99 19.03 0 6.63 3.4 12.45 8.55 15.81-.04 0-.13.04-.18.04-.72.45-1.43.85-2.1 1.39-4.66 3.54-7.17 8.28-8.28 13.93-.13.72 0 1.16.45 1.7.67.72 1.3 1.43 1.97 2.1.72-1.79 2.51-5.78 3.63-6.81 1.16-1.16-1.84 5.37-2.64 7.75 1.93 1.66 3.94 3.09 6.22 4.21 3.54 1.7 7.17 2.64 11.02 2.64l-3.99-5.46 2.06-11.96-2.06-3.31 1.39-1.93c-.94-.18-1.88-.49-2.78-.9-1.57-.72-3-1.79-4.21-3 2.87 1.79 6.31 2.82 9.99 2.82 3.63 0 7.03-1.03 9.85-2.82-2.02 2.02-4.34 3.31-7.03 3.94l1.43 1.93-2.06 3.31 2.06 11.96-3.99 5.37c.54 0 1.07-.04 1.61-.09 2.87-.18 5.73-.94 8.33-2.1 2.42-1.12 4.66-2.51 6.63-4.21-.4-1.7-4.08-9.54-2.78-8.28 1.16 1.25 3.27 6.05 3.81 7.34 1.03-.99 2.02-1.97 2.96-3.09.04-.13.13-.31.13-.45-.58-4.02-2.01-7.69-4.61-10.96z" />
            </svg>
            <div class="absolute inset-y-0 flex items-center text-center">
              <span class="texto text-xs text-gray-200 font-semibold tracking-wide">
                {{ $t("lang.msg.clients") }}
              </span>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-48 xl:w-56 space-y-2 mt-4">
          <HomeButtonRedirect :route="{ name: 'adminSignup' }">
            {{ $t("lang.msg.signUpClients") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminClients' }">
            {{ $t("lang.msg.clients") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminGroups' }">
            {{ $t("lang.msg.group") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminLocations' }">
            {{ $t("lang.msg.location") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminDesigners' }">
            {{ $t("lang.msg.designer") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminBuyer' }">
            {{ $t("lang.msg.buyer") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminSections' }">
            {{ $t("lang.msg.department") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminCollection' }">
            {{ $t("lang.msg.collection") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminSeasons' }">
            {{ $t("lang.msg.season") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminWarehouses' }">
            {{ $t("lang.msg.warehouse") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminSuppliers' }">
            {{ $t("lang.msg.suppliers") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminCharging' }">
            {{ $t("lang.msg.chargingMethods") }}
          </HomeButtonRedirect>
        </div>
      </div>
      <!-- ===================== --->
      <!-- === FOURTH COLUMN === --->
      <!-- ===================== --->
      <div class="flex flex-col items-center bg-gray-100 pb-8 my-8 md:mb-0">
        <div class="w-20 h-20 md:w-24 md:h-24 -mt-8 md:-mt-12 rounded-full bg-secundario">
          <div class="carta w-20 h-20 md:w-24 md:h-24">
            <svg
              class="w-12 h-12 fill-current text-gray-100"
              fill="none"
              xml:space="preserve"
              viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M63.14 57.2l-.04-12.64V7.94c0-.27-.09-.54-.18-.76-.14-.18-.31-.31-.49-.31H50.96c-.18 0-.36.13-.49.31s-.18.45-.18.76v24.03L25.94 13.43c-.22-.18-.49-.18-.71-.09-.22.13-.4.36-.4.63v16.88L1.96 13.43c-.18-.13-.45-.18-.71-.04-.22.13-.4.36-.4.63v43.32c0 .18.09.36.22.49s.31.17.49.17h60.91c.22 0 .4-.09.54-.22.09-.18.18-.41.13-.58zM17.28 37.59c0 .18-.04.31-.18.4-.13.13-.27.18-.4.18H7.81c-.18 0-.31-.04-.4-.18-.09-.09-.18-.27-.18-.4V35c0-.13.04-.31.18-.4.09-.09.27-.18.4-.18h8.89c.18 0 .31.04.4.18.13.09.18.27.18.4v2.59zm23.89 0c0 .18-.04.31-.18.4-.13.13-.27.18-.4.18H31.7c-.18 0-.31-.04-.4-.18-.13-.09-.18-.27-.18-.4V35c0-.13.04-.31.18-.4.09-.09.27-.18.4-.18h8.89c.18 0 .31.04.4.18.09.09.18.27.18.4v2.59z" />
            </svg>
            <div class="absolute inset-y-0 flex items-center text-center">
              <span class="texto text-xs text-gray-200 font-semibold tracking-wide">
                {{ $t("lang.msg.factory") }}
              </span>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-48 xl:w-56 space-y-2 mt-4">
          <HomeButtonRedirect :route="{ name: 'adminSignup' }">
            {{ $t("lang.msg.signUpFactories") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminFactories' }">
            {{ $t("lang.msg.factories") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminSubstructures' }">
            {{ $t("lang.msg.substructures") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminProcesses' }">
            {{ $t("lang.msg.processes") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminCertificates' }">
            {{ $t("lang.msg.certificates") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminAgents' }">
            {{ $t("lang.msg.agent") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminMethods' }">
            {{ $t("lang.msg.shippingMethods") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminLabs' }">
            {{ $t("lang.msg.laboratory") }}
          </HomeButtonRedirect>
          <HomeButtonRedirect :route="{ name: 'adminPayments' }">
            {{ $t("lang.msg.paymentMethods") }}
          </HomeButtonRedirect>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeAdminSection",
  data() {
    return {};
  }
};
</script>